import EligibilityStandards from './EligibilityStandards';
export { EligibilityStandards };
export default EligibilityStandards;
